import { render, staticRenderFns } from "./ProfileCardModal.vue?vue&type=template&id=1271d954&"
import script from "./ProfileCardModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileCardModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCardModal.vue?vue&type=style&index=0&id=1271d954&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports